import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  TextField,
  Typography,
} from "@mui/material";
import React, { Suspense } from "react";
import Checkbox from "../../../../../../Components/CheckBox/Checkbox";
import { MODEL_GROUPS } from "./LLMUtils";
import { ExpandMore, InfoOutlined } from "@mui/icons-material";
import PromptNode from "../PromptNode/PromptNode";
import Loader from "../../../../../../Components/Loader";
import { accordionStyles } from "../../../../../../Constants/accordionStyles";
import { inputStyles } from "../../../../../../Constants/inputStyles";
import theme, { createLLMTypography } from "../../../../../../Constants/theme";
import { foundationalStyles } from "./FountaionalStyles";
import { childNodeNavText, topNavNode } from "../GeneralNodeStyles";

const FoundationalModels = ({
  LLMFoundational,
  handleLLMFoundationalChange,
  expandedPanel,
  setExpandedPanel,
  LLM,
  handleLLMChange,
  temperature,
  handleTemperatureChange,
  outputTokenLimit,
  handleOutputTokensLimitChange,
  data,
  basicPrompt,
  setBasicPrompt,
  organization,
  handleOpenSideBar,
}) => {
  return (
    <Box
      sx={{
        ...foundationalStyles.container,
        opacity: LLMFoundational ? 1 : 0.7,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 2,
          width: "50%",
        }}
      >
        <Box sx={foundationalStyles.listBox}>
          <Box sx={topNavNode}>
            <Typography sx={childNodeNavText}>Select LLM Models</Typography>
            <div>
              <InfoOutlined
                onClick={(event) => handleOpenSideBar("generation", event)}
              />
            </div>
          </Box>
          <Box
            sx={{
              padding: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
              pt: 1,
            }}
          >
            {MODEL_GROUPS.map((group) => (
              <Accordion
                disableGutters={true}
                key={group.key}
                expanded={expandedPanel === group.key}
                onChange={() =>
                  setExpandedPanel((prev) =>
                    prev === group.key ? false : group.key
                  )
                }
                sx={foundationalStyles.accordion}
              >
                <AccordionSummary
                  expandIcon={
                    <ExpandMore sx={{ color: theme.textColors.dark.primary }} />
                  }
                  sx={foundationalStyles.summary}
                >
                  {group.title}
                </AccordionSummary>
                <AccordionDetails sx={foundationalStyles.details}>
                  {group.models.map(({ label, onChangeName, proOnly }) => {
                    const disabled =
                      !LLMFoundational ||
                      ((proOnly || group.proOnly) &&
                        organization?.subscription === "starter");
                    const checked = !!LLM[onChangeName];

                    return (
                      <Box
                        key={onChangeName}
                        sx={foundationalStyles.checkboxRow}
                      >
                        <Checkbox
                          customLabelStyles={{
                            marginLeft: "5px",
                            fontSize:
                              createLLMTypography.fontSizes.sectionTitle,
                          }}
                          label={label}
                          checked={checked}
                          disabled={disabled}
                          onChange={(e) => handleLLMChange(e, onChangeName)}
                          tooltipText={
                            disabled &&
                            "You need Pro subscription to access this."
                          }
                        />
                      </Box>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>

        <Box sx={foundationalStyles.paramBox}>
          <Box sx={topNavNode}>
            <Typography sx={childNodeNavText}>Set LLM Parameters</Typography>
            <div>
              <InfoOutlined
                onClick={(event) => handleOpenSideBar("generation", event)}
              />
            </div>
          </Box>
          <Box
            sx={{
              padding: 2,
              display: "flex",
              flexDirection: "column",
              gap: 1,
              pt: 1,
            }}
          >
            <TextField
              label="Temperature (0 - 1)"
              value={temperature}
              onChange={handleTemperatureChange}
              disabled={!LLMFoundational}
              sx={{
                marginTop: 1,
                cursor: LLMFoundational ? "text" : "not-allowed",
                ...inputStyles.textField,
                "& .MuiInputLabel-root": {
                  color: theme.inputs.textColor,
                  fontSize: "13px",
                },
              }}
            />
            <TextField
              label="Output Tokens Limit"
              value={outputTokenLimit}
              onChange={handleOutputTokensLimitChange}
              disabled={!LLMFoundational}
              sx={{
                cursor: LLMFoundational ? "text" : "not-allowed",
                ...inputStyles.textField,
                "& .MuiInputLabel-root": {
                  color: theme.inputs.textColor,
                  fontSize: "13px",
                },
              }}
            />
          </Box>
        </Box>
      </Box>

      <Suspense fallback={<Loader />}>
        <PromptNode
          data={data}
          initial_prompt={basicPrompt}
          setInitial_prompt={setBasicPrompt}
          LLMFoundational={LLMFoundational}
          handleOpenSideBar={handleOpenSideBar}
        />
      </Suspense>
    </Box>
  );
};

export default FoundationalModels;
